import {
  Activity,
  ClipboardList,
  CreditCard,
  Files,
  Globe,
  Inbox,
  LayoutDashboard,
  Mailbox,
  Package,
  Plug,
  Shield,
  Sparkles,
  Tag,
  UserRound,
  UsersRound,
  X,
} from "lucide-react";
import * as React from "react";
import { useCallback } from "react";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenuButton,
  SidebarRail,
  useSidebar,
} from "@/components/ui/sidebar";
// import { NavUser } from "./nav-user";
import { useGetActiveSubscriptionPlans } from "@/hooks/use-subscription";
import { cn } from "@/lib/utils";
// import { useAuth } from "@clerk/clerk-react";
import { Button } from "../ui/button";
import { Card } from "../ui/card";
import { SingleMenu } from "./single-menu";
import { OrganizationSwitcher } from "../organization/organization-switcher";
import { usePermission } from "@/hooks/use-premission";

// This is sample data.

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { data: activeSubscriptionPlans } = useGetActiveSubscriptionPlans();
  const { hasPermission } = usePermission();

  const hasActiveSubscription =
    activeSubscriptionPlans && activeSubscriptionPlans.length > 0;

  const sideBarItems = React.useMemo(() => {
    return {
      navMain: [
        {
          title: "Dashboard",
          url: "/dashboard",
          icon: LayoutDashboard,
          isVisible: true,
          disabled: false,
        },
        {
          title: "Mailboxes",
          url: "/mailboxes",
          icon: Mailbox,
          isVisible:
            hasPermission("organization:admin") ||
            hasPermission("mailboxes:view"),
          disabled: false,
        },
        {
          title: "Postmaster",
          url: "/postmaster",
          icon: Globe,
          isVisible:
            hasPermission("organization:admin") ||
            hasPermission("postmaster:view"),
          disabled: false,
        },
        {
          title: "Domain Health Test",
          url: "/domain-health",
          icon: Activity,
          isVisible:
            hasPermission("organization:admin") ||
            hasPermission("email_health:view"),
          disabled: false,
        },
        {
          title: "Inbox Placement Test",
          url: "/placement-test",
          icon: Inbox,
          isVisible:
            hasPermission("organization:admin") ||
            hasPermission("inbox_placement:view"),
          disabled: false,
        },
        {
          title: "Seed List",
          url: "/seed-list/seed-counts",
          icon: ClipboardList,
          isVisible:
            hasPermission("organization:admin") ||
            hasPermission("seed_list:view"),
          disabled: false,
        },

        {
          title: "Templates",
          url: "/templates",
          icon: Files,
          isVisible:
            hasPermission("organization:admin") ||
            hasPermission("templates:view"),
          disabled: false,
        },

        {
          title: "Labels",
          url: "/labels",
          icon: Tag,
          isVisible:
            hasPermission("organization:admin") || hasPermission("labels:view"),
          disabled: false,
        },
        {
          title: "Integration",
          url: "/integration",
          icon: Plug,
          isVisible:
            hasPermission("organization:admin") ||
            hasPermission("integration:view") ||
            hasPermission("api_access:view"),
          disabled: false,
        },
      ],

      settings: [
        {
          title: "Team Management",
          url: "/team-management",
          icon: UsersRound,
          isVisible:
            hasPermission("organization:admin") || hasPermission("team:view"),
          disabled: false,
        },
        {
          title: "Roles",
          url: "/roles",
          icon: Shield,
          isVisible:
            hasPermission("organization:admin") || hasPermission("roles:view"),
          disabled: false,
        },
        {
          title: "Plans",
          url: "/plans",
          icon: Package,
          isVisible:
            hasPermission("organization:admin") ||
            hasPermission("billing:view"),
          disabled: false,
        },
        {
          title: "Billing",
          url: "/billing",
          icon: CreditCard,
          isVisible:
            hasPermission("organization:admin") ||
            hasPermission("billing:view"),
          disabled: false,
        },
      ],
    };
  }, [hasPermission]);

  return (
    <Sidebar collapsible="icon" variant="sidebar" {...props} className="">
      <SidebarHeader>
        {/* <TeamSwitcher teams={data.teams} /> */}

        <div className="flex items-center gap-2">
          {/* <Avatar className="rounded-md">
            <AvatarImage src="https://github.com/shadcn.png" />
            <AvatarFallback>CN</AvatarFallback>
          </Avatar> */}
          <SidebarMenuButton
            size="lg"
            className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
          >
            {/* <div className="aspect-square size-8 rounded-md flex items-center justify-center bg-sidebar-primary">
              <img
                src="/mail.svg"
                alt="InboxDoctor"
                className="size-6"
              />
            </div> */}
            <img
              src="/id-logo.png"
              alt="InboxDoctor"
              className="size-10 rounded-md"
            />
            <div className="flex flex-col whitespace-nowrap">
              <img
                src="/id-logo-text.png"
                alt="InboxDoctor"
                className="max-w-[120px] dark:invert"
              />
              {/* <p className="text-lg font-bold">InboxDoctor</p> */}
              {/* <p className="text-xs text-muted-foreground">john@doe.com</p> */}
            </div>
          </SidebarMenuButton>
        </div>
      </SidebarHeader>

      <SidebarContent>
        <SingleMenu label="Main" items={sideBarItems.navMain} />
        <SingleMenu label="Settings" items={sideBarItems.settings} />
        {/* <NavProjects projects={data.projects} /> */}
      </SidebarContent>

      <SidebarFooter>
        <UpgradeCard />
        <OrganizationSwitcher showPersonal={false} />
        {/* <NavUser/> */}
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const UpgradeCard = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const { open: isSidebarOpen } = useSidebar();

  return null;
};
